var _circle, _ellipse, _path, _ellipse2, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLensesPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 43.5,
    stroke: "#DDDDDD"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.7403,
    cy: 38.7574,
    rx: 10.0253,
    ry: 3.12604,
    transform: "rotate(130.737 31.7403 38.7574)",
    fill: "#5FD0FB",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9111 41.919C44.9062 38.0664 44.353 34.193 43.1479 30.9955C43.0931 30.8508 42.9975 30.7557 42.8652 30.7065C41.5706 30.2237 36.7403 34.1886 32.0105 39.4058C27.0356 44.8929 23.5965 50.1189 24.0381 51.4473C24.0592 51.5108 24.0861 51.5681 24.1253 51.6132C26.6306 54.5185 33.5943 54.5802 38.7521 50.1579",
    stroke: "#DDDDDD",
    strokeWidth: 1.66667
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51,
    cy: 55.9997,
    rx: 14,
    ry: 4,
    fill: "#5FD0FB",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5601 52.1423C26.5236 50.8537 29.1048 49.0894 31.2209 47.1615C37.0576 41.8432 40.8576 35.8818 43.2836 31.1498",
    stroke: "#DDDDDD",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7575 42.9078C39.8756 43.2751 37.1635 44.0228 36.8095 44.9353C36.784 45.0009 36.7666 45.0669 36.7659 45.1344C36.7173 49.8487 42.7441 56.5398 50.26 56.655C57.7765 56.7701 62.0586 51.3599 63.9647 45.8279C64.0183 45.6726 64.0096 45.52 63.9453 45.3709C63.3108 43.9061 57.2234 42.7743 50.4023 42.6701C47.9904 42.633 45.7235 42.7216 43.7575 42.9078",
    stroke: "#DDDDDD",
    strokeWidth: 1.66667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7656 45.6615C38.9684 46.2594 41.9064 47.0026 44.6139 47.3195C52.0799 48.1935 58.4858 47.2468 63.1488 46.0797",
    stroke: "#DDDDDD",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLensesPlaceholder);
export default __webpack_public_path__ + "static/media/lenses-placeholder.2b7145f0a48018c767a1956217786acf.svg";
export { ForwardRef as ReactComponent };